import { buildCollection, buildProperty } from "@firecms/core";
import { HomeButton } from "../components/HomeButton";

export type BadgeNFT = {
    badge_id: string;
    badge_name: string;
    badge_category: string;
    badge_tier: string;
    user_id: number;
    owner_address: string;
    nft_index: number;
    nft_address: string;
    mint_status: string;
    mint_tx_hash: string;
    image_url: string;
    collection_id: string;
    created_at: Date;
};

export const badgeNFTsCollection = buildCollection<BadgeNFT>({
    id: "badge_nfts",
    name: "Badge NFTs",
    singularName: "Badge NFT",
    path: "badge_nfts",
    icon: "MilitaryTech",
    group: "NFT",
    Actions: HomeButton,
    description: "Minted badge NFTs — monitor on-chain mint statuses",
    permissions: {
        edit: false,
        create: false,
        delete: false,
    },
    properties: {
        badge_id: buildProperty({
            name: "Badge",
            dataType: "string",
            readOnly: true,
        }),
        badge_name: buildProperty({
            name: "Badge Name",
            dataType: "string",
            readOnly: true,
        }),
        badge_category: buildProperty({
            name: "Category",
            dataType: "string",
            readOnly: true,
        }),
        badge_tier: buildProperty({
            name: "Tier",
            dataType: "string",
            readOnly: true,
            enumValues: {
                bronze: "🥉 Bronze",
                silver: "🥈 Silver",
                gold: "🥇 Gold",
                platinum: "💎 Platinum",
                legendary: "🏆 Legendary",
            },
        }),
        user_id: buildProperty({
            name: "User ID",
            dataType: "number",
            readOnly: true,
        }),
        owner_address: buildProperty({
            name: "Wallet Address",
            dataType: "string",
            readOnly: true,
        }),
        mint_status: buildProperty({
            name: "Mint Status",
            dataType: "string",
            readOnly: true,
            enumValues: {
                pending: "⏳ Pending",
                minted: "✅ Minted",
                failed: "❌ Failed",
                unconfirmed: "⚠️ Unconfirmed",
            },
        }),
        nft_index: buildProperty({
            name: "NFT Index",
            dataType: "number",
            readOnly: true,
        }),
        nft_address: buildProperty({
            name: "NFT Address",
            dataType: "string",
            readOnly: true,
        }),
        mint_tx_hash: buildProperty({
            name: "TX Hash",
            dataType: "string",
            readOnly: true,
        }),
        image_url: buildProperty({
            name: "Image URL",
            dataType: "string",
            readOnly: true,
            url: true,
        }),
        collection_id: buildProperty({
            name: "Collection ID",
            dataType: "string",
            readOnly: true,
        }),
        created_at: buildProperty({
            name: "Minted At",
            dataType: "date",
            mode: "date_time",
            readOnly: true,
        }),
    },
    propertiesOrder: [
        "badge_name",
        "badge_tier",
        "user_id",
        "mint_status",
        "nft_address",
        "owner_address",
        "mint_tx_hash",
        "nft_index",
        "image_url",
        "created_at",
    ],
});
